import { render, staticRenderFns } from "./dui-review-rating.vue?vue&type=template&id=50997604&scoped=true&"
import script from "./dui-review-rating.vue?vue&type=script&lang=js&"
export * from "./dui-review-rating.vue?vue&type=script&lang=js&"
import style0 from "./dui-review-rating.vue?vue&type=style&index=0&id=50997604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50997604",
  null
  
)

export default component.exports